import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageTransition } from '../components/PageTransition';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const Landing = () => {
  const navigate = useNavigate();
  const {
    t
  } = useLanguage();
  return <PageTransition className="justify-center p-6 text-center" data-id="element-146">
      <div className="flex-1 flex flex-col items-center justify-start pt-8 max-w-sm mx-auto w-full" data-id="element-147">
        <h1 className="w-full mb-6" data-id="element-148">
          <img src="https://cdn.magicpatterns.com/uploads/4tRqpowk1G8qQnNNh2VQ2D/Skarmavbild_2026-06-21_kl._17.47.40.png" alt="Top Notch Bakery" className="w-full max-w-xs mx-auto h-auto" data-id="element-149" />
        </h1>

        <div className="flex items-center justify-center gap-2 mb-6 text-terracotta font-medium tracking-wide text-sm uppercase" data-id="element-150">
          {t('landing.subtitle')}
        </div>

        <p className="text-espresso-light mb-10 text-[18px] font-[500] font-[Merriweather,_serif]" data-id="element-151">
          {t('landing.intro')}
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/iwvU6S5kVX6UqnTh2d1vgS/Skarmavbild_2026-06-21_kl._17.56.20.png" alt="Evedals Camping Växjö" className="w-full max-w-[150px] mx-auto h-auto mb-6" data-id="element-152" />

        <button onClick={() => navigate('/pickup')} className="w-full bg-espresso hover:bg-espresso-light text-white rounded-2xl p-4 font-medium flex items-center justify-center gap-2 transition-colors active:scale-[0.98]" data-id="element-153">
          {t('landing.cta')}
          <ArrowRight size={18} data-id="element-154" />
        </button>
      </div>
    </PageTransition>;
};